import * as Dialog from '@radix-ui/react-dialog';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router';

import { Button } from '~/components/ui/button';
import { Icon } from '~/components/ui/icon';

export function WelcomeSplash() {
  const [searchParams] = useSearchParams();
  const splashFlag = searchParams.get('splash');
  const [open, setOpen] = useState(splashFlag === '1');

  useEffect(() => {
    setOpen(splashFlag === '1');
  }, [splashFlag]);

  if (!open) {
    return null;
  }

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay
          forceMount
          className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
        />

        <Dialog.Content
          className="fixed left-[50%] top-[50%] z-50 grid max-h-[96dvh] w-full max-w-4xl translate-x-[-50%] translate-y-[-50%] gap-4 overflow-y-auto bg-background shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full"
          tabIndex={undefined}
        >
          <div className="flex flex-col tablet:flex-row">
            <div className="flex items-center bg-black bg-opacity-80 bg-[url('/img/landing-header-bg-3.jpg')] bg-cover bg-center bg-blend-darken sm:rounded-tl-lg sm:rounded-tr-lg tablet:flex-1 tablet:basis-1/2 tablet:rounded-bl-lg tablet:rounded-tr-none">
              <h1 className="p-12 text-center text-primary-foreground">
                Welcome to Fighters Passport!
              </h1>
            </div>

            <div className="flex flex-col gap-6 p-12 tablet:flex-1 tablet:basis-1/2">
              <CallToAction
                title="Claim Your Business"
                description="Are you a Gym Owner? Contact us to get a personalized demo and learn how Fighters Passport can grow your business."
                buttonText="Request Demo"
                link="/request-demo"
              />

              <CallToAction
                title="Complete Your Profile"
                description="Take a few minutes to build out the rest of your profile."
                buttonText="Manage Profile"
                link="/account/profile"
              />

              <CallToAction
                title="Ready to Roll"
                description="Start searching for gyms near you and discover the classes they offer!"
                buttonText="Find gyms & classes"
                link="/gym"
              />
            </div>
          </div>

          <Dialog.Close className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
            <Icon name="x" className="h-4 w-4 text-primary-foreground tablet:text-primary" />
            <span className="sr-only">Close</span>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

function CallToAction({
  title,
  description,
  buttonText,
  link,
}: {
  title: string;
  description: string;
  buttonText: string;
  link: string;
}) {
  return (
    <div>
      <h2 className="text-subtitle1">{title}</h2>
      <p className="text-body2">{description}</p>
      <Button asChild className="mt-2">
        <Link to={link}>{buttonText}</Link>
      </Button>
    </div>
  );
}
